export default [{  // 商品列表
	path: 'product_list',
	name: 'm_product',
	props: route => route.query,
	component: () => import('@/pages/product/product_list')
}, {  // 商品详情
	path: 'product_detail/:id',
	props: route => route.params,
	component: () => import('@/pages/product/product_detail')
}, {  // 商品发布
	path: 'product_apply',
	props: route => route.query,
	component: () => import('@/pages/product/product_apply')
}, {  // 商品编辑
	path: 'product_edit/:id',
	props: route => route.params,
	component: () => import('@/pages/product/product_edit')
}, {  // 商品分类
	path: 'product_group',
	name: 'm_product_group',
	component: () => import('@/pages/product/product_group')
},{  // 商品问答
	path: 'product_question_list',
	name: 'm_produc_qa',
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/pages/product/product_question_list')
},{  // 回答列表
	path: 'product_answer_list',
	name: 'm_produc_answer_list',
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/pages/product/product_answer_list')
}];